import { useRef } from "react";
import { Tooltip } from "src/components/Tooltip/Tooltip";
import { Flex, Icon, Color } from "src/elements";
import { useHoverClickable } from "src/utils/hoverClickable";
import { styled } from "styled-components";

const SidepanelToggleElement = styled(Flex)`
  width: 100%;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
`;

interface Props {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}

export const SidepanelToggleButton = ({ isExpanded, setIsExpanded }: Props) => {
  const refButton = useRef(null);
  const { isHovered, isActive } = useHoverClickable(refButton);

  return (
    <SidepanelToggleElement
      ref={refButton}
      background={
        (isActive && Color.greenSmokeActive) ||
        (isHovered && Color.greenSmokeHover) ||
        Color.greenSmokeDisabled
      }
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <Icon
        name={isExpanded ? "chevronRight" : "chevronLeft"}
        color={((isHovered || isActive) && Color.primaryActive) || Color.primary}
      />

      <Tooltip position="left">{isExpanded ? "Hide Sidebar" : "Show Sidebar"}</Tooltip>
    </SidepanelToggleElement>
  );
};
